// @flow
import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { compose } from "redux";


import * as selectors from "../../../modules/selectors";
import * as actions from "../../../modules/actions";
import type { TPLeague, TRound } from "../../../modules/types";

import PageContentWrapper from "../../../components/PageContentWrapper";
import TwoColumnLayout
from "../../../components/TwoColumnLayout";
import JsonFetcher from "../../../components/utils/JsonFetcher";
import withRoundsSelector from "../../../components/utils/withRoundsSelector";
import RoundSelector from "../../../components/RoundSelector";
import AdsContainer from "../../../components/AdsContainer";
import Ad from "../../../components/Ad";
import Footer from "../../../components/Footer";
import TeamBreakdowns from "../../../components/TeamBreakdowns";
import { PageTitle } from "../../../components/PageTitle";
import { StandardSidebar, withDraftPlayerModal, Preloader } from "../../../components";
import withCoachesBox from "../../../components/utils/withCoachesBox";
import LeagueGameBar from "../../../components/LeagueGameBar";
import { isAllTrue, isAnyTrue } from "../../../helpers";
import { isRoundActive, isRoundComplete } from "../../../helpers/rounds";

type Props = {
	selected_league_id: number,
	fetchLeague: typeof actions.leagueDraft.showDraftLeague,
	fetchLeagueRosters: typeof actions.leagueDraft.fetchLeagueRosters,
	user_id: number,
	rounds_ordered: Array<Object>,
	selected_round_id: number,
	setSelectedRoundId: Function,
	league: TPLeague,
	rosters: Array<Object>,
	team_breakdown_players: Object,
	showModalForPlayerId: Function,
	actual_round: TRound,
}

type State = {
	is_selected_round: number
}

class LeagueTeamBreakdownsPage extends React.Component<Props, State> {
	state = {
		is_selected_round: 0,
	};
	componentDidMount() {
		this.fetchLeague();
	}
	


	componentDidUpdate(prev_props, prevState) {
		const { selected_league_id, 
			selected_round_id, 
			setSelectedRoundId, league, 
			actual_round } = this.props;

		if (
			isAllTrue([
				Boolean(selected_league_id), 
				selected_league_id !== prev_props.selected_league_id
			])
			
		) {
			this.fetchLeague();
			// this.fetchLeagueRosters();
		}
		else if (
			selected_round_id !== prev_props.selected_round_id
		) {
			this.fetchLeagueRosters();
		}
		if(isAllTrue([
			!_.isEmpty(actual_round),
			this.state.is_selected_round === 0
		])){
			setSelectedRoundId(this.league_selected_round);
			this.setState({
				is_selected_round: 1
			});
		}
		if(isAllTrue([
			!_.isEmpty(actual_round),
			this.state.is_selected_round === 1,
			prevState.is_selected_round === 0,
		])){
			this.fetchLeagueRosters();
		}
		if (
			isAnyTrue([
				selected_league_id !== prev_props.selected_league_id,
				league !== prev_props.league
			])
		) {
			setSelectedRoundId(this.league_selected_round);
		}
	}

	get league_rounds() {
		const {
			rounds_ordered,
			league
		} = this.props;

		if (rounds_ordered && league && league.start_round && league.end_round) {
			return rounds_ordered.filter(round =>
				(round.id >= league.start_round && round.id <= league.end_round) &&
				(
					round.id === league.start_round ||
					isRoundActive(round) ||
					isRoundComplete(round)
				)
			);
		}

		return rounds_ordered;
	}

	get league_selected_round() {
		const { selected_round_id, league } = this.props;

		if (selected_round_id && league) {
			const start_round = _.first(this.league_rounds).id;
			const end_round = _.last(this.league_rounds).id;

			if ( selected_round_id < start_round) {
				return start_round;
			}
			else if (selected_round_id > end_round) {
				return end_round;
			}

			return selected_round_id;
		}

		return  null;
	}

	fetchLeagueRosters() {
		const { fetchLeagueRosters, selected_league_id, 
			selected_round_id, actual_round } = this.props;
		const actual_round_id = _.get(actual_round, "id");
		if(_.isEmpty(actual_round) || selected_round_id < 1 || this.state.is_selected_round !== 1){
			return ;
		}

		const leagueRosterPayload = selected_round_id === actual_round_id ? {
			league_id: selected_league_id
		} : {
			league_id: selected_league_id,
			round: selected_round_id
		};
		
		fetchLeagueRosters(leagueRosterPayload);
		
		
	}

	fetchLeague() {
		const { fetchLeague, selected_league_id } = this.props;
		fetchLeague({
			id: selected_league_id
		});
	}

	renderMainSection() {
		const {
			league,
			selected_round_id,
			setSelectedRoundId,
			user_id,
			rosters,
			team_breakdown_players,
			actual_round,
			showModalForPlayerId,
		} = this.props;
		 return (
			<div>
				<RoundSelector
					selected={selected_round_id}
					rounds={this.league_rounds}
					handleClick={setSelectedRoundId}
				/>
				<TeamBreakdowns
					rosters={rosters}
					team_breakdown_players={team_breakdown_players}
					league_id={league.id}
					round_id={selected_round_id}
					user_id={user_id}
					showModalForPlayerId={showModalForPlayerId}
					actual_round_id={_.get(actual_round, 'id')}
				/>
			</div>
		 );
	}

	render() {
		const {
			league,
			rosters
		} = this.props;
		const title_league_name = league ? league.name : "-";
		if(rosters[0] === undefined){
			return <React.Fragment>
				<Preloader />
				<JsonFetcher fetch={["rounds", "players"]} />
			</React.Fragment> ;
		}
		return (
			<React.Fragment>
				<JsonFetcher fetch={["rounds", "players"]} />

				<LeagueGameBar />

				<AdsContainer>
					<Ad />
				</AdsContainer>


				<PageContentWrapper>
					<PageTitle>
						Teams Breakdowns for {title_league_name}
					</PageTitle>
					<TwoColumnLayout>
						{this.renderMainSection()}
						<StandardSidebar />
					</TwoColumnLayout>
				</PageContentWrapper>
				<Footer />
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state, props) => {
	const selected_league_id = props.match.params.league_id;
	const actual_round = selectors.rounds.getActualRound(state);
	return {
		selected_league_id,
		actual_round,
		league: selectors.leagues.getLeague(state, props),
		team_breakdown_players: selectors.players.getTeamBreakdownPlayersById(state),
		rosters: selectors.leagues.rosters.getOrdered(state),
		user_id: selectors.getUser(state).id	
	};
};

const mapDispatchToProps = {
	fetchLeague: actions.leagueDraft.showDraftLeague,
	fetchLeagueRosters: actions.leagueDraft.fetchLeagueRosters,
	showModalForPlayerId: actions.showModalForPlayerId,
};

export const LeagueTeamBreakdowns = compose(
	withRoundsSelector,
	withCoachesBox,
	withDraftPlayerModal,
	connect(
		mapStateToProps,
		mapDispatchToProps
	)
)(LeagueTeamBreakdownsPage);

export default LeagueTeamBreakdowns;